import axios from "axios";
import { msalInstance, scopes } from "@/config/authConfig";
import {
  ClientConfigurationError,
  InteractionRequiredAuthError,
} from "@azure/msal-browser";

const instance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL,
});

instance.interceptors.request.use(
  async (config) => {
    if (config.headers) {
      if (config.headers["Content-Type"] !== "multipart/form-data") {
        config.headers["Content-Type"] = "application/json";
      }
    }

    const account = msalInstance.getAllAccounts()[0];
    if (account) {
      const accessTokenRequest = {
        scopes: scopes,
        account: account,
      };

      await msalInstance
        .acquireTokenSilent(accessTokenRequest)
        .then((response) => {
          const accessToken = response.accessToken;

          if (config.headers && accessToken) {
            config.headers["Authorization"] = `Bearer ${accessToken}`;
          }
        })
        .catch((error) => {
          if (error instanceof ClientConfigurationError) {
            msalInstance.logoutRedirect();
          }

          // Call acquireToken with redirect in case of acquireTokenSilent failure
          if (error instanceof InteractionRequiredAuthError) {
            msalInstance
              .acquireTokenRedirect(accessTokenRequest)
              .catch((error) => {
                console.log(error);
              });
          }
        });
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  async function (response) {
    return response;
  },
  async (error) => {
    if (error.response.status === 401) {
      //call your api for refresh token
      const account = msalInstance.getAllAccounts()[0];
      if (account) {
        const accessTokenRequest = {
          scopes: scopes,
          account: account,
        };
        await msalInstance
          .acquireTokenSilent(accessTokenRequest)
          .then((response) => {
            const accessToken = response.accessToken;

            if (error.config.headers && accessToken) {
              error.config.headers["Authorization"] = `Bearer ${accessToken}`;
            }
          })
          .catch((error) => {
            if (error instanceof ClientConfigurationError) {
              msalInstance.logoutRedirect();
            }

            // Call acquireToken with redirect in case of acquireTokenSilent failure
            if (error instanceof InteractionRequiredAuthError) {
              msalInstance
                .acquireTokenRedirect(accessTokenRequest)
                .catch((error) => {
                  console.log(error);
                });
            }
          });

        return instance(error.config);
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
